import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Accordion": Accordion, "@mui/material/AccordionDetails": AccordionDetails, "@mui/material/AccordionSummary": AccordionSummary, "@mui/material/Typography": Typography, "@mui/icons-material/ExpandMore": ExpandMoreIcon } } });
export default ClientProvider;
